const Config: any = {
  BaseUrl: "https://api.solusinegeri.com/",
};

export default Config;
